<template>
  <div id="departmentSelector">
    <div class="selector-box">
      <div class="left-box">
        <template v-if="list[0] && list[0].children">
          <p @click="getAllOff" :class="{ 'active': firstSeled == 0 }">全部</p>
          <p v-for="(item, index) in list[0].children" :class="{ 'active': firstSeled == item.id }"
            @click="selectorOrg(item, index)" :key="index">{{ item.organName }}</p>
        </template>
      </div>
      <template v-if="firstSeled == 0">
        <div class="right-box"
             v-if="list[0] && list[0].children && list[0].children[activeIdx].children && list[0].children[activeIdx].children.length > 0">
          <div>
            <p :class="{ 'active': secondSeled == '' }" @click="selectorDepartment({id:''})" :key="index">
              全部
            </p>
          </div>
          <div v-for="(children, childrenIndex) in list[0].children" :key="childrenIndex">
            <p v-for="(item, index) in children.children" :class="{ 'active': secondSeled == item.id }"
               @click="selectorDepartment(item)" :key="index">{{ item.organName }}
            </p>
          </div>
        </div>
        <div class="right-box" v-else>
          <h3 class="nodata">暂无数据</h3>
        </div>
      </template>
      <template v-if="firstSeled !== 0">
        <div class="right-box"
          v-if="list[0] && list[0].children && list[0].children[activeIdx].children && list[0].children[activeIdx].children.length > 0">
          <p v-for="(item, index) in list[0].children[activeIdx].children" :class="{ 'active': secondSeled == item.id }"
            @click="selectorDepartment(item)" :key="index">{{ item.organName }}</p>
        </div>
        <div class="right-box" v-else>
          <h3 class="nodata">暂无数据</h3>
        </div>
      </template>
      <div class="select-btn">
        <van-button type="primary" block color="var(--main-color)" @click="fixDepartment">确定</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";

export default {
  name: "DepartmentSelector",
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    selectorObj: {
      type: Object,
      default: () => {
        return {
          orgSelector: {},
          departmentSelector: {}
        }
      }
    }
  },
  data() {
    return {
      activeIdx: 0,
      deptSelect: true,
      firstSeled: 0,
      secondSeled: 0
    }
  },
  created() {
    this.init();
  },
  watch: {
    list: {
      handler(newVal) {
        this.firstSeled = 0;
        // newVal[0].children[0].id;
        // this.secondSeled = newVal[0].children[0].children[0].id;
      },
      deep: true
    }
  },
  methods: {
    getAllOff() {
      this.firstSeled = 0;
      this.$emit('getAllOff');
    },
    init() {
      // this.org = this.selectorOrg.orgSelector;
      // this.dept = this.selectorOrg.departmentSelector;
      let orgId = this.selectorObj.orgSelector.id;
      this.list.forEach((item, index) => {
        if (item.id == orgId) {
          this.activeIdx = index;
          return
        }
      })
    },
    // 机构点击事件
    selectorOrg(e, index) {
      this.activeIdx = index;
      this.firstSeled = e.id;
      this.selectorDepartment(null);
      this.$emit('selectedOrg', e)
      if (this.list[0].children[index].children.indexOf(this.selectorObj.departmentSelector) != -1) {
        this.deptSelect = true;
      } else {
        this.deptSelect = false;
      }
    },
    // 部门点击事件
    selectorDepartment(e) {
      if (e) {
        this.deptSelect = true;
        this.secondSeled = e.id;
      } else {
        this.deptSelect = false;
      }
      this.$emit('selectedDepartment', e)
    },
    // 确定点击事件
    fixDepartment() {
      if (this.deptSelect) {
        this.$emit('fixedSelector')
      } else {
       
        Toast({message:'请选择部门'});
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@/assets/css/theme/theme.scss";


#departmentSelector {
  height: 215px;
}

.selector-box {
  display: flex;
  width: 100%;
  height: 215px;
  background: #fff;
  padding-bottom: 60px;
  position: absolute;
  left: 0;
  z-index: 999;

  .left-box {
    width: 88px;
    height: 215px;
    background: #f7f7f7;
    overflow-x: hidden;
    overflow-y: auto;
    flex-shrink: 0;
    @extend .color333;
    @extend .font13;

    p {
      height: 56px;
      line-height: 56px;
      padding: 0 10px;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &.active {
        background: var(--main-color);
        color: #fff;
      }
    }
  }

  .right-box {
    height: 215px;
    padding: 13px 20px;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: auto;
    flex: 1;
    @extend .color333;
    @extend .font14;

    p {
      height: 35px;
      line-height: 35px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &.active {
        color: var(--main-color);
      }
    }
  }

  .select-btn {
    height: 40px;
    padding: 10px 15px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;

    .van-button {
      height: 40px;
      border-radius: 5px;
    }
  }

  .nodata {
    color: #333;
    margin-top: 12px;
    text-align: center;
    font-size: 14px;
  }
}
</style>